
const state = {
	language: 'zh', //en zh
}
const mutations = {}
const actions = {}
export default {
	state,
	mutations,
	actions
}